interface Column {
  id: string;
  label: string;
  width?: string;
}
export const OpenPositionsColumns: Column[] = [
  { id: "strategy", label: "Strategy" },
  { id: "contract", label: "Contract" },
  { id: "action", label: "Action" },
  { id: "qty", label: "Qty" },
  { id: "midPrice", label: "Mid Price" },
  { id: "netCredit", label: "Net Credit/Debit" },
  { id: "profitloss", label: "P&L" },
  { id: "value", label: "Value" },
  { id: "stopprofit", label: "Stop Loss/Take Profit" },
  { id: "closePosition", label: "" },
];

export const OpenOrdersColumns: Column[] = [
  { id: "strategy", label: "Strategy", width: "15%" },
  { id: "contract", label: "Contract Type", width: "13%" },
  { id: "qty", label: "Qty (Filled/Total)", width: "13%" },
  { id: "status", label: "Status", width: "11%" },
  { id: "unitPrice", label: "Unit Price", width: "11%" },
  { id: "totalCost", label: "Total Cost (Est.)", width: "12%" },
  { id: "orderType", label: "Order Type", width: "11%" },
];

export const OrderHistoryColumns: Column[] = [
  { id: "strategy", label: "Strategy" },
  { id: "symbol", label: "Symbol" },
  { id: "contract", label: "Contract" },
  { id: "avgPrice", label: "Average Price" },
  { id: "orderVal", label: "Order Value" },
  { id: "qty", label: "Quantity" },
  { id: "status", label: "Status" },
  { id: "transacted", label: "Transacted on" },
];
